module.exports = __webpack_public_path__ + "static/img/6.bb80bc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/6.png
// module id = eC+4
// module chunks = 0